import styled from 'styled-components';
import { useReturnExchangesValueContextHook } from '../../contexts/ReturnExchangesContext';
import { TdReturnExchangeType } from './fragments/td-return-exchange-type';
import { TdReturnExchangeProceedStatus } from './fragments/td-return-exchange-proceed-status';
import { TdProductInfo } from './fragments/td-product-info';
import { TdReceiverInfo } from './fragments/td-receiver-info';
import { TdWaybillInfo } from './fragments/td-waybill-info';
import { TdDestinationInfo } from './fragments/td-destination-info';
import { TdExchangeInfo } from './fragments/td-exchange-info';
import { TdClaimInfo } from './fragments/td-claim-info';
import { TdMemoInfo } from './fragments/td-memo-info';
import { TdOriginOrderInfo } from './fragments/td-origin-order-info';
import { FragmentSearchAndPagination } from './fragments/fragment-search-and-pagination';
import { TdOrderNumberInfo } from './fragments/td-order-number-info';
import { TdArchive } from './fragments/td-archive';
import { useSelectedReturnExchangesActionsContextHook, useSelectedReturnExchangesValueContextHook } from '../../contexts/SelectedReturnExchangesContext';
import { TdExchangeStockReflect } from './fragments/td-exchange-stock-reflect';
import { TdCollectionProductInfo } from './fragments/td-collection-product-info';
import { TdInventoryReceive } from './fragments/td-inventory-receive';
import { TdSalesChannelInfo } from './fragments/td-sales-channel-info';
import { TdInspectionResultMemo } from './fragments/td-inspection-result-memo';
import { useEffect, useRef } from 'react';
import { useQueryParamsHook } from '../../../../../utils/useQueryParamsHook';
import { TdDooray } from './fragments/td-dooray';

const StyledContainer = styled.div`
    padding: 16px;
`;

const StyledTableContainer = styled.div`
  overflow: auto;
  margin: 0;
  box-shadow: var(--shadow-sm);
  border-radius: 12px;
  width: 100%;
  max-height: calc(100vh - 260px);
  min-height: 320px;
  border: 1px solid #eceef1;
  background: #ffffff;
`;

const StyledTable = styled.table`
  table-layout: auto;    /* 내용 길이에 맞춰 열 너비 자동 */
  white-space: nowrap;   /* 한 줄로 표시하여 열이 자동 확장 */
  border-collapse: collapse;
  background-color: #ffffff;
`;

const StyledTableHeader = styled.thead`
    position: sticky;
    top: 0;
    z-index: 2;
    background-color: #fafbfc;
`

const StyledTableHeaderCell = styled.th`
    padding: 14px 16px;
    text-align: left;
    font-weight: 600;
    color: #6b7280;
    border-bottom: 1px solid #eceef1;
    white-space: nowrap;
    font-size: 12px;
    letter-spacing: 0.01em;
    background-color: #fafbfc;
`

const StyledTableRow = styled.tr`
    transition: background-color 0.15s ease, box-shadow 0.15s ease;
    cursor: pointer;

    &:hover {
        background-color: #f6f8fb;
    }

    &.selected{
        background-color: rgba(82, 123, 255, 0.08) !important;
        box-shadow: inset 3px 0 0 var(--primary);
    }
`

const StyledTableCell = styled.td`
  padding: 14px 16px;
  color: #374151;
  border-bottom: 1px solid #f1f3f5;
  font-size: 13px;
`

export function WegetTable(props) {
    const scrollRef = useRef();
    const queryParamsHook = useQueryParamsHook();
    const pageParam = queryParamsHook?.params?.page;

    const selectedReturnExchangesValueContextHook = useSelectedReturnExchangesValueContextHook();
    const returnExchangesValueContextHook = useReturnExchangesValueContextHook();
    const returnExchanges = returnExchangesValueContextHook?.returnExchanges;

    useEffect(() => {
        if (scrollRef.current) {
            scrollRef.current.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        }
    }, [pageParam]);
    return (
        <>
            <StyledContainer>
                <FragmentSearchAndPagination />
                <StyledTableContainer ref={scrollRef}>
                    <StyledTable>
                        <StyledTableHeader>
                            <tr>
                                <StyledTableHeaderCell>보관함</StyledTableHeaderCell>
                                <StyledTableHeaderCell>반품/교환 타입</StyledTableHeaderCell>
                                <StyledTableHeaderCell>진행상태</StyledTableHeaderCell>
                                <StyledTableHeaderCell>검수결과</StyledTableHeaderCell>
                                <StyledTableHeaderCell>주문번호1</StyledTableHeaderCell>
                                <StyledTableHeaderCell>출고 상품정보</StyledTableHeaderCell>
                                <StyledTableHeaderCell>회수 상품정보</StyledTableHeaderCell>
                                <StyledTableHeaderCell>입고반영</StyledTableHeaderCell>
                                <StyledTableHeaderCell>판매채널정보</StyledTableHeaderCell>
                                <StyledTableHeaderCell>수취인정보</StyledTableHeaderCell>
                                <StyledTableHeaderCell>송장정보</StyledTableHeaderCell>
                                <StyledTableHeaderCell>주소</StyledTableHeaderCell>
                                <StyledTableHeaderCell>교환정보</StyledTableHeaderCell>
                                <StyledTableHeaderCell>교환 재고반영</StyledTableHeaderCell>
                                <StyledTableHeaderCell>클레임</StyledTableHeaderCell>
                                <StyledTableHeaderCell>메모</StyledTableHeaderCell>
                                <StyledTableHeaderCell>원 주문정보</StyledTableHeaderCell>
                                <StyledTableHeaderCell>두레이 발송</StyledTableHeaderCell>
                            </tr>
                        </StyledTableHeader>
                        <tbody>
                            {returnExchanges?.map((returnExchange, index) => {
                                const isSelected = selectedReturnExchangesValueContextHook.selectedReturnExchanges.some(r => r._id === returnExchange?._id);

                                return (
                                    <TableRow
                                        key={returnExchange?._id}
                                        returnExchange={returnExchange}
                                        rowIndex={index}
                                        isSelected={isSelected}
                                    />
                                );
                            })}
                        </tbody>
                    </StyledTable>
                </StyledTableContainer>
            </StyledContainer>
        </>
    );
}

function TableRow({
    returnExchange,
    rowIndex,
    isSelected,
}) {
    const selectedReturnExchangesActionsContextHook = useSelectedReturnExchangesActionsContextHook();

    const handleRowSelect = () => {
        selectedReturnExchangesActionsContextHook.selectedReturnExchanges.setValue(prev => {
            const newSelectedReturnExchanges = [...prev];
            const index = newSelectedReturnExchanges.findIndex(selectedReturnExchange => selectedReturnExchange._id === returnExchange._id);
            if (index === -1) {
                newSelectedReturnExchanges.push(returnExchange);
            } else {
                newSelectedReturnExchanges.splice(index, 1);
            }
            return newSelectedReturnExchanges;
        })
    }

    return (
        <StyledTableRow onClick={(e) => { handleRowSelect(); }} className={`${isSelected ? 'selected' : ''}`}>
            <TdArchive
                returnExchange={returnExchange}
            />
            <TdReturnExchangeType
                returnExchange={returnExchange}
            />
            <TdReturnExchangeProceedStatus
                returnExchange={returnExchange}
            />
            <TdInspectionResultMemo
                returnExchange={returnExchange}
            />
            <TdOrderNumberInfo
                returnExchange={returnExchange}
            />
            <TdProductInfo
                returnExchange={returnExchange}
            />
            <TdCollectionProductInfo
                returnExchange={returnExchange}
            />
            <TdInventoryReceive
                returnExchange={returnExchange}
            />
            <TdSalesChannelInfo
                returnExchange={returnExchange}
            />
            <TdReceiverInfo
                returnExchange={returnExchange}
            />
            <TdWaybillInfo
                returnExchange={returnExchange}
            />
            <TdDestinationInfo
                returnExchange={returnExchange}
            />
            <TdExchangeInfo
                returnExchange={returnExchange}
            />
            <TdExchangeStockReflect
                returnExchange={returnExchange}
            />
            <TdClaimInfo
                returnExchange={returnExchange}
            />
            <TdMemoInfo
                returnExchange={returnExchange}
            />
            <TdOriginOrderInfo
                returnExchange={returnExchange}
            />
            <TdDooray 
                returnExchange={returnExchange}
            />
        </StyledTableRow>
    );
}